var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPodcast = function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 0a3 3 0 0 0-3 3v8a3 3 0 1 0 6 0V3a3 3 0 0 0-3-3M0 11a7.001 7.001 0 0 0 6 6.93V20H3v2h8v-2H8v-2.07A7.001 7.001 0 0 0 14 11V8h-2v3a5 5 0 0 1-10 0V8H0z",
    clipRule: "evenodd"
  })));
};
export default SvgPodcast;